export default {
  GOOGLE_API_KEY: 'AIzaSyDhhXQX8dl9TGpJVjLs16gl4Ynj8r-mxfI',
  GOOGLE_LIBRARIES: 'places',
  SERVER_URL: 'https://coveragemap.comreg.ie/comreg-map',
  TOAST_TIME: 3000,
  PLATFORM: 'web',
  APP_NAME: 'icmap-coverage-map'
};
